import { useEffect, useRef, useState } from 'react';

// Arrow keys move between grid cells while a cell input has focus
export function useCellArrowNav(activeCell, setActiveCell, size) {
  useEffect(() => {
    const handleKeyDown = e => {
      if (e.target.className !== 'cell-input') return;

      const { row, col } = activeCell;
      let newRow = row, newCol = col;

      switch(e.key) {
        case 'ArrowUp': newRow = Math.max(0, row - 1); e.preventDefault(); break;
        case 'ArrowDown': newRow = Math.min(size.height - 1, row + 1); e.preventDefault(); break;
        case 'ArrowLeft': newCol = Math.max(0, col - 1); e.preventDefault(); break;
        case 'ArrowRight': newCol = Math.min(size.width - 1, col + 1); e.preventDefault(); break;
        default: return;
      }

      setActiveCell({ row: newRow, col: newCol });
      setTimeout(() => {
        const input = document.querySelector(`[data-pos="${newRow}-${newCol}"]`);
        if (input) {
          input.focus();
          input.setSelectionRange(input.value.length, input.value.length);
        }
      }, 0);
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [activeCell, size]); // eslint-disable-line react-hooks/exhaustive-deps
}

// Cell size follows the space available: 40px in the desktop three-column
// layout, larger (up to 52px) when the editor stacks on narrow screens (<= 1024px).
export function useGridLayout(displayCols) {
  const centerRef = useRef(null);
  const [stacked, setStacked] = useState(() => window.innerWidth <= 1024); // single-column layout
  const [cellSize, setCellSize] = useState(40);
  useEffect(() => {
    const el = centerRef.current;
    if (!el) return;
    const measure = () => {
      const narrow = window.innerWidth <= 1024;
      const fit = Math.floor((el.clientWidth - 6) / displayCols); // 6 = outer grid border
      setStacked(narrow);
      setCellSize(Math.max(24, Math.min(narrow ? 52 : 40, fit)));
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [displayCols]);
  return { centerRef, stacked, cellSize };
}
